import React from 'react';

import JobList from '../../features/jobs/components/JobList';

const JobsList: React.FC = () => <JobList />;

export default JobsList;
